import { classnames } from '@aibees/shared/utils';
import { memo, useState } from 'react';
import * as Styled from './styles';
import type { SeeMoreProps as Props } from './types';

export const SeeMore = memo(({ className, maxChars = 100, text }: Props) => {
  const [showFullText, setShowFullText] = useState(false);

  const toggleText = () => {
    setShowFullText(!showFullText);
  };

  let displayText;
  if (text) {
    if (showFullText) displayText = text;
    else displayText = `${text?.slice(0, maxChars)}...`;
  }

  return (
    <Styled.Wrapper className={classnames('SeeMore', className)}>
      <Styled.TextWrapper variant="body4">
        {displayText}
        {text && text.length > maxChars && (
          <Styled.ToggleButton
            size="xsmall"
            variant="text"
            color="primary"
            onClick={toggleText}
          >
            {showFullText ? 'Show Less' : 'Show More'}
          </Styled.ToggleButton>
        )}
      </Styled.TextWrapper>
    </Styled.Wrapper>
  );
});

SeeMore.displayName = 'SeeMore';
